import "./InputText.scss";
import Avatar from "core/avatar/Avatar";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import PropTypes from "prop-types";
import _ from "lodash";
import { FormattedMessage, useIntl } from "react-intl";
import { useState } from "react";
import { getFormattedDate } from "utils/functions";
import { ACTIONS } from "constants/constants";

const renderCommentSection = ({
  id,
  model,
  comment,
  lang,
  commentAction,
  setCommentOpened,
  isLastComment,
  intl,
  canUserDeleteComment,
}) => {
  const user = comment?.user || comment?.updated_by;
  const content = comment?.comment || comment?.content;
  const date = comment?.date || getFormattedDate(comment?.updated_at, lang);
  const { picture_url, first_name, last_name } = user || {};
  const commentAuthorInitials =
    first_name && last_name && `${first_name[0]}${last_name[0]}`;
  return (
    <div className="comment-wrapper" id={id}>
      <div className="comment-info">
        {!_.isEmpty(user) && (
          <Avatar
            replace={!_.isEmpty(picture_url)}
            size="x-small"
            initials={commentAuthorInitials}
            id={id}
          />
        )}
        <div>
          <div className="comment-user-label">
            {`${
              first_name + last_name ||
              intl.formatMessage({
                id: "unknown",
                defaultMessage: "Inconnu",
              })
            }`}
          </div>
          <div className="comment-date">{date}</div>
          <div className="comment-text">{content}</div>
          {canUserDeleteComment && (
            <div className="comment-delete-group">
              <Icon color="deep-purple" icon="trash-2" width={15} height={15} />
              <button
                className="comment-delete"
                onClick={() => {
                  commentAction?.({
                    action: ACTIONS.DELETE,
                    commentId: comment?.id,
                    model,
                  });
                  isLastComment && setCommentOpened(false);
                }}
              >
                <FormattedMessage
                  id={"delete_comment"}
                  defaultMessage={"Supprimer le commentaire"}
                />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const InputTextComments = ({
  left,
  value,
  id,
  settings,
  onClick,
  isAddCommentAction,
  isCommentsInput,
  lang,
  commentAction,
  setCommentOpened,
  model,
  canUserDeleteComment,
}) => {
  const intl = useIntl();
  const [commentInput, setCommentInput] = useState("");

  return (
    <div
      className="input-text-commentary"
      style={{ marginLeft: `${left / 10}px`, zIndex: "5" }}
      id="input-text-commentary"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "right",
          marginRight: "15px",
          position: "sticky",
          top: "15px",
        }}
      >
        <Icon
          color="deep-purple"
          icon="close"
          width={15}
          height={15}
          onClick={() => setCommentOpened(false)}
        />
      </div>
      {(!isAddCommentAction || !isCommentsInput) &&
        _.map(value || [], (data, index) =>
          renderCommentSection({
            id: index,
            model,
            comment: data,
            lang,
            commentAction,
            setCommentOpened,
            isLastComment: value?.length === 1,
            intl,
            canUserDeleteComment,
          })
        )}
      {(isAddCommentAction || !isCommentsInput) && (
        <>
          <div className="input-text-commentary-content">
            <textarea
              className="input-text-commentary-content-message"
              value={commentInput}
              onChange={(e) => setCommentInput(e.target.value)}
              placeholder={intl.formatMessage(settings.placeholder)}
              id={`input-text-area-${id}`}
            />
          </div>
          <div className="input-text-commentary-buttons">
            <Button
              color="btn-standard gray-700"
              onClick={() => onClick(commentInput)}
              id={`button-${id}`}
              disabled={!commentInput}
            >
              <FormattedMessage {...settings.button_value} />
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

InputTextComments.propTypes = {
  left: PropTypes.any,
  value: PropTypes.string,
  setCommentOpened: PropTypes.func.isRequired,
  commentOpened: PropTypes.bool.isRequired,
  id: PropTypes.string,
  settings: PropTypes.object,
  onClick: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  getValue: PropTypes.func.isRequired,
  isAddCommentAction: PropTypes.bool,
  isCommentsInput: PropTypes.bool,
  lang: PropTypes.string,
  commentAction: PropTypes.func,
};

InputTextComments.defaultProps = {
  value: "",
  left: null,
  id: "",
  settings: {},
  readOnly: false,
};

export default InputTextComments;
